export default "__VITE_ASSET__DGlehGn1__"